'use strict';

export default class TutorController {
  /*@ngInject*/
  constructor($http, Modal, JSONToCSVConvertor) {
    this.$http = $http;
    this.Modal = Modal;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
  }

  $onInit() {
    this.grab();
  }

  grab() {
    this.$http.get('/api/tutors')
      .then(response => {
        this.tutors = response.data;
      });
  }

  export(data) {
    data = data.map(entity =>({
      _id: entity._id,
      dateModified: entity.dateModified,
      firstName: entity.firstName,
      lastName: entity.lastName,
      phone: entity.phone,
      fullName: entity.fullName,
      email: entity.email,
      dateCreated: entity.dateCreated,
      isActive: entity.isActive
    }))
    this.JSONToCSVConvertor(data, 'Tutor Export', true);
  }

  addTutor(newTutor) {
    if(newTutor) {
      newTutor.fullName = `${newTutor.firstName} ${newTutor.lastName}`;
      this.$http.post('/api/tutors', newTutor)
      .then(() => {
        this.grab();
        this.error = '';
      })
      .catch(res => {
        this.error = JSON.stringify(res.data, null, '\t');
      });
    }
  }

  toggleActive(tutor) {
    tutor.isActive = !tutor.isActive;
    this.$http.put(`/api/tutors/${tutor._id}`, {isActive: tutor.isActive});
  }

  patchTutor(tutor, callback) {
    if(tutor) {
      tutor.fullName = `${tutor.firstName} ${tutor.lastName}`;
      this.$http.put(`/api/tutors/${tutor._id}`, tutor)
        .then(() => {
          this.grab();
          this.error = '';
          callback();
        })
        .catch(res => {
          this.error = JSON.stringify(res.data, null, '\t');
        });
    }
  }

  openModal(tutor) {
    this.Modal.editTutor(tutor);
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/tutor/tutor.controller.js